import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df2d4c18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item item-video" }
const _hoisted_2 = { class: "img" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "meta-info"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看", -1))
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "inner" }
const _hoisted_10 = { class: "meta" }
const _hoisted_11 = { class: "meta-title" }

import { ref, reactive, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemProjectVideo',
  props: {
  data: {
    type: Object,
    required: false,
  },
},
  setup(__props) {

const props = __props
const rate = ref(0)
const prjUrl = computed(() => {
  return '/project/' + state.id
})
const state = reactive({ ...(props.data || {}) })
rate.value = Number(state.userStarLevel) || 0

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_el_rate = _resolveComponent("el-rate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "poster",
        to: `/coop/${state.id}`
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: state.coverImage
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["to"]),
      (state.video)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_svg_icon, { icon: "icon_play" }),
            _hoisted_5
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(state.title), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_rate, {
                modelValue: rate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rate).value = $event)),
                class: "star",
                disabled: ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("span", null, _toDisplayString(state.province) + _toDisplayString(state.city), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})